export default __webpack_public_path__ + "static/media/martin_qiub.a1666a5d.png";